import { useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { updateAimsId } from '../services/project/userService';

const UpdateAimsIdModal = ({ user, show, onClose, refetch = () => {} }) => {
  const formik = useFormik({
    initialValues: {
      aimsId: user?.aimsId ?? '',
    },
    enableReinitialize: true,
    onSubmit: async ({ aimsId }, { setSubmitting }) => {
      try {
        const response = await updateAimsId(user.id, aimsId?.trim?.() ?? aimsId ?? '');
        if (!response?.success) {
          toast.error(response?.data?.errorMessage || response?.message || 'Failed to update AIMS ID');
          return;
        }
        toast.success(response?.message || 'AIMS ID updated');
        refetch();
        onClose();
      } catch (error) {
        console.error('Error updating AIMS ID:', error);
        toast.error(error?.response?.data?.errorMessage || 'Something went wrong');
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        document.getElementById('aimsIdInput')?.focus();
      }, 100);
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update AIMS ID</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group className="mb-3" controlId="aimsIdInput">
            <Form.Label>AIMS ID</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter AIMS ID"
              {...formik.getFieldProps('aimsId')}
              disabled={formik.isSubmitting}
            />
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={onClose} disabled={formik.isSubmitting}>
              Cancel
            </Button>
            <Button type="submit" variant="primary" disabled={formik.isSubmitting}>
              {formik.isSubmitting ? 'Saving…' : 'Save'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateAimsIdModal;
